<template>
    <v-dialog scrollable transition="fab-transition" content-class="create_dialog" width="800" style="background:transparent;" @keydown.enter="next_step" @keydown.esc="$store.state.APP.SHOW_CREATE=false" v-model="$store.state.APP.SHOW_CREATE">

        <v-stepper v-if="$store.state.APP.SHOW_CREATE" v-model="$store.state.APP.CREATE_PAGE">
            <v-img  :src="require('../assets/audience_ye3.jpg')">
                <v-row
                        style="height:100%;"
                        align="center"
                        justify="center"
                >

                    <v-col cols="6">
                        <h4 style="text-align: center;"><v-icon dark right>mdi-checkbox-marked-circle</v-icon>Swish-donationer</h4>
                    </v-col>
                    <v-col cols="6">
                        <h4 style="text-align: center;"><v-icon dark right>mdi-checkbox-marked-circle</v-icon>Sponsorer</h4>
                    </v-col>

                </v-row>

            </v-img>
            <v-stepper-header  >
                <v-stepper-step color="#56d89f" :complete="$store.state.APP.CREATE_PAGE > 1" step="1">Skapa konto</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step color="#56d89f" :complete="$store.state.APP.CREATE_PAGE > 2" step="2">Din profil</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step color="#56d89f" :complete="$store.state.APP.CREATE_PAGE > 3" step="3">Alerts</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-form v-model="new_account_valid">
                        <v-container>
                            <v-row>
                                <v-col
                                        cols="6"
                                        md="6"
                                >

                                    <v-text-field
                                            v-model="new_username"
                                            :rules="rules.new_username.concat(new_name_taken_f)"
                                            label="Användarnamn"

                                            required
                                    ></v-text-field>
                                </v-col>

                                <v-col
                                        cols="6"
                                        md="6"
                                >
                                    <v-text-field
                                            v-model="new_email"
                                            :rules="rules.new_email.concat(new_email_taken_f)"
                                            label="E-mail"
                                            required
                                    ></v-text-field>
                                </v-col>

                                <v-col
                                        cols="6"
                                        md="6"
                                >
                                    <v-text-field
                                            v-model="new_password"

                                            :rules="rules.new_password"
                                            :type="new_password_show ? 'text' : 'password'"
                                            label="Lösenord"
                                    >
                                        <template v-slot:append>
                                            <v-btn tabindex="-1" @click="new_password_show = !new_password_show" icon>
                                                <v-icon>{{new_password_show ? 'mdi-eye' : 'mdi-eye-off'}}</v-icon>
                                            </v-btn>
                                        </template>

                                    </v-text-field>
                                </v-col>
                                <v-col
                                        cols="6"
                                        md="6"
                                        style="margin-bottom:40px;"
                                >
                                    <v-text-field
                                            v-model="new_password_repeat"
                                            :rules="[passwordConfirmationRule]"
                                            :type="new_password_show_repeat ? 'text' : 'password'"
                                            label="Repetera lösenord"
                                    >
                                        <template v-slot:append>
                                            <v-btn tabindex="-1" @click="new_password_show_repeat = !new_password_show_repeat" icon>
                                                <v-icon>{{new_password_show_repeat ? 'mdi-eye' : 'mdi-eye-off'}}</v-icon>
                                            </v-btn>
                                        </template>

                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <v-footer
                            absolute

                    >
                            <v-spacer></v-spacer>
                            <v-btn
                                    style="margin-bottom: 4px;"
                                    color="#56d89f"
                                    :loading="el1_button_loading"
                                    @click="register_account"
                                    class="white--text"
                                    :disabled="!new_account_valid"
                            >
                                Fortsätt
                            </v-btn>

                    </v-footer>



                </v-stepper-content>

                <v-stepper-content style="max-height: 60vh;overflow-y: scroll;" step="2">

                    <h2 style="color:black;text-align: center;">Välkommen {{$store.state.STREAMER.USER_NAME}}!</h2>
                    <p style="color:black;text-align: center;">Fortsätt med guiden om du snabbt vill konfigurera ditt konto för att ta emot donationer</p>

                    <v-card
                            class="mx-auto my-8"
                            max-width="400px"
                            raised
                            id="donation_card"
                            style="position:relative;z-index: 1;margin-bottom:60px !important;"
                    >
                        <v-card-text>
                            <div>Donationer</div>

                            <v-row class="mt-10">
                                <v-col style="padding-top:0;padding-bottom:0;" class="col-12">
                                    <v-radio-group v-model="$store.state.STREAMER.PAYMENT_TYPE">
                                        <v-radio
                                                value="SWISH"
                                                color="#56d89f"
                                                @click.native="setPayment('SWISH')"
                                        >
                                            <template slot="label">
                                                Hihat-<b>direkt</b>
                                            </template>

                                        </v-radio>
                                        <v-radio

                                                value="BANK2"
                                                @click.native="setPayment('BANK2')"
                                                color="#56d89f"



                                        >
                                            <template slot="label">
                                                Hihat-<b>classic</b><v-chip small class="ml-2">Rekommenderas</v-chip>
                                            </template>

                                        </v-radio>
                                    </v-radio-group>

                                </v-col>
                                <v-row class="px-4" v-if="$store.state.STREAMER.PAYMENT_TYPE==='BANK2'">
                                    <v-col class="col-6">
                                      <v-text-field
                                          label="Telefonnummer"
                                          placeholder=""
                                          type="number"
                                          v-model="$store.state.STREAMER.PHONE_NUMBER"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col class="col-6">
                                        <v-text-field
                                                label="Personnummer"
                                                v-model="$store.state.STREAMER.PERSONAL_NUMBER"
                                                placeholder="YYMMDD-XXXX"
                                                :rules="rules.personal_number"



                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="col-6">
                                        <v-text-field
                                                label="Förnamn"
                                                placeholder=""
                                                v-model="$store.state.STREAMER.FIRST_NAME"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="col-6">
                                        <v-text-field
                                                label="Efternamn"
                                                placeholder=""
                                                v-model="$store.state.STREAMER.LAST_NAME"

                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row v-if="$store.state.STREAMER.PAYMENT_TYPE==='SWISH'" class="px-4">
                                    <v-col  class="col-7">
                                        <v-text-field
                                                label="Telefonnummer"
                                                placeholder=""
                                                type="number"
                                                v-model="$store.state.STREAMER.PHONE_NUMBER"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>


                            </v-row>



                        </v-card-text>
                        <v-card-subtitle v-if="$store.state.STREAMER.PAYMENT_TYPE==='BANK2'" >
                            Donationer betalas anonymt ut i en klumpsumma till dig varje månad den 25:e. Dina personuppgifter hålls hemliga för de som donerar.
                        </v-card-subtitle>
                        <v-card-subtitle v-if="$store.state.STREAMER.PAYMENT_TYPE==='SWISH'">
                            Donationer levereras direkt till din Swish. De som donerar får genom Bank-ID tillgång till ditt telefonnummer och ditt namn.
                        </v-card-subtitle>


                    </v-card>
                    <v-footer
                            absolute

                    >
                            <v-btn
                                    style="margin-bottom: 4px;"
                                    @click="$store.state.APP.SHOW_CREATE=false"

                            >
                                Skippa Guide
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                    style="margin-bottom: 4px;"
                                    color="#56d89f"
                                    @click="$store.state.APP.CREATE_PAGE= 3"
                                    class="white--text"
                                    :disabled="!donation_setup"

                            >
                                Fortsätt
                            </v-btn>

                    </v-footer>



                </v-stepper-content>

                <v-stepper-content style="max-height: 60vh;overflow-y: scroll;"  step="3">
                    <h2 style="color:black;text-align: center">Alerts!</h2>
                    <p style="color:black;text-align: center">Välj det alert-system du gillar bäst </p>
                    <v-row justify="center" style="min-height:100%;margin-bottom:60px;" align="center">
                        <v-col class="col-12 col-lg-4">

                        <v-card
                                height="200"
                                class="mx-auto"
                                style="border: solid 6px #5ed0a6;"

                        >
                            <v-avatar  style="position: absolute;top:0;right:0;" tile class="mr-0" height="40" width="40">
                                <img
                                        :src="require('../assets/hi_icon.png')"
                                >
                            </v-avatar>



                            <v-card-actions style="margin-top:60px;">
                                <v-btn  dark :outlined="!$store.state.STREAMER.HIHAT" @click="new_hihat"  color="#5ed0a6" class="mx-auto">
                                    <v-icon v-if="$store.state.STREAMER.HIHAT"  right>mdi-checkbox-marked-circle</v-icon>
                                    <span >Hihat</span>

                                </v-btn>


                            </v-card-actions>
                            <v-card-actions class="mt-4">

                            </v-card-actions>

                        </v-card>
                        </v-col>


                        <v-col class="col-12 col-lg-4">

                            <v-card
                                    height="200"
                                    class="mx-auto"
                                    style="border: solid 6px orange;"

                            >
                                <v-avatar  style="position: absolute;top:0;right:0;" class="mr-0" height="40" width="40">
                                    <img
                                            :src="require('../assets/streamelements_icon.png')"
                                    >
                                </v-avatar>



                                <v-card-actions style="margin-top:60px;">
                                    <v-btn color="orange" dark :outlined="!$store.state.STREAMER.STREAMELEMENTS" @click="new_streamelements"  class="mx-auto">
                                        <v-icon v-if="$store.state.STREAMER.STREAMELEMENTS" dark right>mdi-checkbox-marked-circle</v-icon>
                                        <span v-if="!$store.state.STREAMER.STREAMELEMENTS">Streamelements</span>

                                    </v-btn>


                                </v-card-actions>
                                <v-row class="mt-2" align="center" justify="center">
                                    <v-col cols="12" align="center" justify="center">
                                        <v-btn text style="" small @click="test_donation" v-show="$store.state.STREAMER.STREAMELEMENTS" class="mx-auto">Skicka test-donation</v-btn>


                                    </v-col>

                                </v-row>



                            </v-card>

                        </v-col>
                        <v-col class="col-12 col-lg-4">

                            <v-card
                                    height="200"
                                    class="mx-auto"
                                    style="border: solid 6px teal;"

                            >
                                <v-avatar  style="position: absolute;top:0;right:0;" class="mr-0" height="40" width="40">
                                    <img
                                            :src="require('../assets/streamlabs_icon.png')"
                                    >
                                </v-avatar>



                                <v-card-actions style="margin-top:60px;">
                                    <v-btn dark @click="new_streamlabs" :outlined="!$store.state.STREAMER.STREAMLABS" color="teal" class="mx-auto">
                                        <v-icon v-if="$store.state.STREAMER.STREAMLABS" dark right>mdi-checkbox-marked-circle</v-icon>
                                        <span >Streamlabs</span>

                                    </v-btn>


                                </v-card-actions>
                                <v-card-actions class="mt-4">
                                    <v-btn text @click="test_donation" small v-show="$store.state.STREAMER.STREAMLABS" class="mx-auto">Skicka test-donation</v-btn>
                                </v-card-actions>

                            </v-card>
                        </v-col>
                    </v-row>
                    <v-footer
                            absolute



                    >
                        <v-btn
                                style="margin-bottom: 4px;"
                                @click="$store.state.APP.SHOW_CREATE=false"

                        >
                            Skippa Guide
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                style="margin-bottom: 4px;"
                                color="#56d89f"
                                @click="$store.state.APP.CREATE_PAGE= 4"
                                class="white--text"
                                :disabled="(!this.$store.state.STREAMER.STREAMELEMENTS) && (!$store.state.STREAMER.STREAMLABS) && (!$store.state.STREAMER.HIHAT)"

                        >
                            Fortsätt
                        </v-btn>

                    </v-footer>


                </v-stepper-content>
                <v-stepper-content step="4">
                    <v-row align="center" justify="center">
                        <v-col align="center" justify="center" cols="6">
                            <v-img
                                    contain
                                    height="150"
                                    width="150"
                                    :src="$store.state.MEDIA.USER_IMAGE"

                            ></v-img>
                            <v-btn style="width:150px;" class="mx-auto" v-on:click="updateImage" small >Byt profilbild</v-btn>
                        </v-col>


                    </v-row>
                    <v-row justify="center" style="min-height:100%;margin-bottom:30px;" align="center">
                        <v-col class="col-12">
                            <h3 style="text-align: center;color:black;">Klappat och klart!🎉</h3>
                          <p style="color:gray;text-align: center;font-size:14px;margin-top: 24px;">Gå gärna med vår <v-btn  href="https://discord.com/invite/W6PHc2h" target="_blank"  flat outlined color="#5865F2" dark style="background: transparent;" > <v-icon>mdi-discord</v-icon> Discord </v-btn> för nyheter och sponsorebjudanden
                          </p>




                        </v-col>
                    </v-row>


                    <v-footer
                            absolute

                    >

                        <v-spacer></v-spacer>
                        <v-btn
                                style="margin-bottom: 4px;"
                                color="#56d89f"
                                @click="$store.state.APP.SHOW_CREATE=false"
                                class="white--text"

                        >
                            Färdig
                        </v-btn>

                    </v-footer>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <input id="imageInput" style="display:none;" type="file" accept="image/*"   v-on:change="openFile">

    </v-dialog>
</template>

<script>
    import * as k from '../helpers/kontonummer.js'

    export default {
        name: "CreateAccount",
        data(){
            return{
                new_name_taken:false,
                new_email_taken:false,
                el1_button_loading:false,
                new_account_valid:false,
                new_password_show:false,
                new_password_show_repeat:false,
                new_username:"",
                new_email:"",
                new_password:"",
                new_password_repeat:"",
                twitch_loading:false,
                bank_name:"",
                rules: {

                    new_username: [
                        v => !!v || 'Ange ett användarnamn.',
                        v => v.length >= 3 || 'Användarnamnet är för kort',
                    ],
                    new_email: [value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Ange en giltig adress'
                    }],
                    new_password: [value => value.length > 3 || 'Ange ett lösenord'],
                    personal_number: [value => {
                        const pattern = /^^(19|20)?[0-9]{6}[- ]?[0-9]{4}$/
                        return pattern.test(value) || 'Ange ett giltigt personnummer \n YYMMDD-XXXX'
                    }],



                }
            }
        },
        computed:{

            passwordConfirmationRule() {
                return (this.new_password === this.new_password_repeat) || 'Lösenorden matchar inte'
            }
            ,
            new_name_taken_f() {
                return (!this.new_name_taken) || 'Användarnamnet är upptaget'
            }
            ,
            new_email_taken_f() {
                return (!this.new_email_taken) || 'Email-adressen är upptagen'
            },
            donation_setup(){
                if((this.$store.state.STREAMER.PAYMENT_TYPE==="SWISH" || this.$store.state.STREAMER.PAYMENT_TYPE==="BANK2" ) && this.$store.state.STREAMER.PHONE_NUMBER.length>7) {
                    return true
                }
                else if(this.$store.state.STREAMER.PAYMENT_TYPE==="BANK" && this.$store.state.STREAMER.BANKACCOUNT.toString().length>7 && this.$store.state.STREAMER.PERSONAL_NUMBER.toString().length>9) {
                    return true
                }
                else{
                    return false
                }
            },



        },

        methods:{

            next_step:function(){
                if(this.$store.state.APP.CREATE_PAGE===1){
                    this.register_account();
                }
            },

            new_streamlabs:function(){
                this.$cookies.set("new_sl",true);
                window.location.href="/api/api_access"
            },
            new_streamelements:function(){
                this.$cookies.set("new_se",true);
                window.location.href="/api/api_access_se"
            },
            test_donation:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/api_test?';
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {
                        self.$store.commit("update_snackbar","Testdonationen kom inte fram.");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Testdonation skapad!");
                    }

                };
                http.send();
            },
            new_hihat:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/use_hihat_overlay';
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {
                        self.$store.commit("update_snackbar","Ett fel inträffade.");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("use_hihat");



                    }

                };
                http.send();
            },

            test_se_bot:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/se_bot_test?';
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {
                        self.$store.commit("update_snackbar","Testmeddelandet kom inte fram.");


                    }
                    else if(http.readyState === 4 && http.status === 200){

                        self.$store.commit("update_snackbar","Testmeddelande skickat!");

                    }

                };
                http.send();
            },
            openFile:function(file) {

                let input = file.target;


                let reader = new FileReader();
                let self=this;
                reader.onload = function(){

                    //self.$store.state.MEDIA.USER_IMAGE=reader.result;
                    self.$store.commit("USER_IMAGE",reader.result);
                    self.saveNewImage(reader.result);
                };
                reader.readAsDataURL(input.files[0]);
            },
            updateImage:function(){
                document.getElementById("imageInput").click();
            },
            saveNewImage: function(image){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/save_user_image?';
                let params="IMAGE="+image;
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.send(params);
            },
            setPayment:function(paymentType){
                this.$store.commit("update_payment_type",paymentType)
            },
            save_all_settings:function(){
                this.$store.commit("save_streamer");
            },
            register_account:function(){
                this.el1_button_loading=true;

                let http = new XMLHttpRequest();
                let url = '/api/storeuser?';
                http.withCredentials = true;
                let params = 'name=' + this.new_username.toLowerCase() + "&password=" + this.new_password+ "&email=" + this.new_email.toLowerCase();
                http.open('POST', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {//Call a function when the state changes.
                    if (http.readyState === 4 && http.status === 200) {
                        if (http.responseText === "name exists") {
                            self.new_name_taken=true;
                            self.el1_button_loading=false;
                        } else if (http.responseText === "email exists") {
                            self.new_email_taken=true;
                            self.el1_button_loading=false;

                        } else if (http.responseText === "success") {
                            let http = new XMLHttpRequest();
                            http.withCredentials = true;
                            let url = '/api/login?';
                            let params = 'username=' + self.new_username.toLowerCase()+ "&password=" + self.new_password;
                            http.open('POST', url, true);


                            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                            http.onreadystatechange = function () {//Call a function when the state changes.
                                if (http.readyState === 4 && http.status === 200) {
                                    self.$store.state.APP.SHOW_LOGIN=false;
                                    self.$store.dispatch("get_settings_data");
                                    self.$store.dispatch("get_hicards_data");
                                    self.snackbar=true
                                    self.el1_button_loading=false;
                                    self.$store.state.APP.CREATE_PAGE=2;




                                }
                            };
                            http.send(params);
                        }
                    }
                };
                http.send(params);
            },
            create_account:function(){
                this.$store.state.APP.SHOW_LOGIN=false;
                this.$store.state.APP.SHOW_CREATE=true;
            },



        },
        watch:{
            new_email:function(){
                this.new_email_taken=false;
            },
            new_username:function(){
                this.new_name_taken=false;

            },
            "$store.state.STREAMER.BANKACCOUNT":function(){
                if(this.$store.state.STREAMER.BANKACCOUNT){
                    let ba=this.$store.state.STREAMER.BANKACCOUNT;
                    let result=k.kontonummer(ba.toString());
                    this.bank_name=result["bank_name"]
                }

            },
            '$store.state.STREAMER':{immediate: false, handler() {
                if(this.$store.state.APP.SETUP_LOADED){
                    clearTimeout(this.save_streamer_timeout);
                    let self=this;
                    this.save_streamer_timeout=setTimeout(function(){
                        self.save_all_settings();
                    },1500);
                }},deep: true
                }

        }
    }
</script>

<style scoped>

</style>
